/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllPalReauthCaseManagersResponse } from './FindAllPalReauthCaseManagersResponse';
import {
    FindAllPalReauthCaseManagersResponseFromJSON,
    FindAllPalReauthCaseManagersResponseFromJSONTyped,
    FindAllPalReauthCaseManagersResponseToJSON,
} from './FindAllPalReauthCaseManagersResponse';

/**
 * 
 * @export
 * @interface FindAllPalReauthCaseManagers200Response
 */
export interface FindAllPalReauthCaseManagers200Response {
    /**
     * 
     * @type {FindAllPalReauthCaseManagersResponse}
     * @memberof FindAllPalReauthCaseManagers200Response
     */
    data?: FindAllPalReauthCaseManagersResponse;
}

/**
 * Check if a given object implements the FindAllPalReauthCaseManagers200Response interface.
 */
export function instanceOfFindAllPalReauthCaseManagers200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllPalReauthCaseManagers200ResponseFromJSON(json: any): FindAllPalReauthCaseManagers200Response {
    return FindAllPalReauthCaseManagers200ResponseFromJSONTyped(json, false);
}

export function FindAllPalReauthCaseManagers200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPalReauthCaseManagers200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FindAllPalReauthCaseManagersResponseFromJSON(json['data']),
    };
}

export function FindAllPalReauthCaseManagers200ResponseToJSON(value?: FindAllPalReauthCaseManagers200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FindAllPalReauthCaseManagersResponseToJSON(value.data),
    };
}

